var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3666 24C2.84041 23.987 2.33937 23.7722 1.96718 23.4C1.59499 23.0278 1.38016 22.5267 1.36716 22.0006V2.99972H0V1.00362H6.26708V0H15.0666V1.00362H21.3337V2.99972H19.961V21.9994C19.948 22.5256 19.7331 23.0267 19.361 23.3989C18.9888 23.7711 18.4877 23.9859 17.9615 23.9989L3.3666 24ZM6.89936 19.1335H8.8988V5.83329H6.89936V19.1335ZM12.4327 19.1335H14.4321V5.83329H12.4327V19.1335Z",
    fill: "#0279CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.cafcac7d54e0cca2572718e28b38aebb.svg";
export { ForwardRef as ReactComponent };